import { StyleInputType } from '../../styles/inputType';

export const numberIncrementerQuickStylesDefinitions = {
  numberIncrementerButtonBackgroundColor: StyleInputType.COLOR,
} satisfies Record<string, StyleInputType>;
